import service from '@/middleware'

export const profileApi = {

  async getAllApps () {
    const result = await service.http.get('/api/application/all')
    return result
  },

  async getProfileSchema () {
    const result = await service.http.get('/api/profile/schema')
    return result
  },

  async getProfiles (enterpriseIds) {
    const result = await service.http.post('/api/profile/profiles', enterpriseIds)
    return result
  },

  async createProfile (profile) {
    const result = await service.http.post('/api/profile/create', profile)
    return result
  },

  async getProfileById (id) {
    const result = await service.http.get('/api/profile/id?' + new URLSearchParams({ id }).toString())
    return result
  },

  /**
   * Obtiene un perfil de usuario junto con los usuarios asignados
   * @param {*} id
   */
  async getProfileAndUsersById (id) {
    const result = await service.http.get(`/api/profile/assigned-users/${id}`)
    return result
  },

  async getProfileByName (name) {
    const result = await service.http.get('/api/profile/name?' + new URLSearchParams({ name }).toString())
    return result
  },

  async updateProfile (profile) {
    const result = await service.http.put('/api/profile/update', profile)
    return result
  },

  async deleteProfileById (id) {
    const result = await service.http.delete('/api/profile/' + id)
    return result
  },

  /**
   * Asigna usuarios a un perfil
   * @param {*} id
   * @param {*} users
   */
  async assignUsersToProfile (id, users) {
    const result = await service.http.put(`/api/profile/assign-users/${id}`, users)
    return result
  },

  /**
  * Validar la existencia del nombre
  *
  * Devuelve true si ya está asignado a un perfil (para evitar duplicados en el ABM)
  * @param {*} name
  */
  async validateName (name) {
    const response = await service.http.get(`/api/profile/validate-name/${name}`)
    return response
  },

  /**
   * Obtener un arreglo de perfiles para los selectores
   * @param {*} enterpriseIds
   */
  async getAllForSelectorUserABM (enterpriseIds) {
    const response = await service.http.post('/api/profile/selector-user-abm', enterpriseIds)
    return response
  }
}
